//커스텀 / Added by Heejung (2025-12-17) 
//Toggle Cart drawer for redeem pop-up

document.addEventListener('DOMContentLoaded', function() {
  let hasClosedOnce = false;
  
  // Re-open cart drawer if page reloaded after apply code
  if (sessionStorage.getItem('reopenCartAfterReload') === 'true') {
    sessionStorage.removeItem('reopenCartAfterReload');
    
    setTimeout(() => {
      const openBtn = document.querySelector('cart-drawer-component .button.header-actions__action');
      if (openBtn) {
        openBtn.click();
      }
    }, 500);
  }
  
   // Close cart drawer when redeem button clicked
  document.addEventListener('click', function(e) {
    const redeemBtn = e.target.closest('.loyalty-cart-widget-rewards-btn');
    
    if (redeemBtn && !hasClosedOnce) {
      hasClosedOnce = true;
      
      setTimeout(() => {
        const cartDrawer = document.querySelector('.cart-drawer__dialog');
        
        if (cartDrawer && cartDrawer.open) {
          const clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          });
          cartDrawer.dispatchEvent(clickEvent);
        }
        
        setTimeout(() => {
          hasClosedOnce = false;
        }, 1000);
      }, 100);
    }
  });
  
   // Re-open cart drawer when loyalty popup closed
  window.addEventListener('message', function(event) {
    if (typeof event.data !== 'string') return;

    if (event.data === 'hideEarnRedeemWidget') {
      const openBtn = document.querySelector('cart-drawer-component .button.header-actions__action');

      if (openBtn) {
        setTimeout(() => {
          openBtn.click();
        }, 150);
      }
    }
    
    // Set flag to re-open cart drawer after apply code
    if (event.data.startsWith('appstle_message_to_apply_discount_and_reload')) {
      sessionStorage.setItem('reopenCartAfterReload', 'true');
    }
  });
});
